// removed by extract-text-webpack-plugin
module.exports = {"referralSection":"_1wQfVMGfdwhi5BAD5ZVlYJ","input":"_3-4R5wPzT70EMC5wWpW59F","copy":"_1ottUxS9si8cWGmGJpT_ra"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CopyClipboardInput/CopyClipboardInput.scss
// module id = 1595
// module chunks = 0